// Libs
import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
	cursor: pointer;
	transition: transform 0.15s ease, filter 0.15s ease;
	&:hover {
		transform: scale(1.15);
		filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.7));
	}
`;

export default ({ fill = 'white', fillOpacity = '0.80' }) => (
	<Svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		style={{ color: fill }}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9 12H4V6H9V12ZM9 19H4V13H9V19ZM10 19H15V13H10V19ZM21 19H16V13H21V19ZM10 12H15V6H10V12ZM16 12V6H21V12H16Z'
			fill={fill}
			fillOpacity={fillOpacity}
		/>
	</Svg>
);
